/**
 * Normalize API values that may be a real array, a Postgres text array
 * literal like "{Arabic,French}", a JSON array string, or a plain string.
 */
export function toStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }
  if (typeof value !== 'string') {
    return [];
  }
  const s = value.trim();
  if (!s) {
    return [];
  }
  if (s.startsWith('{') && s.endsWith('}')) {
    const inner = s.slice(1, -1).trim();
    if (!inner) {
      return [];
    }
    return inner.split(',').map((item) => item.trim()).filter(Boolean);
  }
  if (s.startsWith('[') && s.endsWith(']')) {
    const parsed = JSON.parse(s);
    if (!Array.isArray(parsed)) {
      throw new Error(`Expected JSON array, got: ${s}`);
    }
    return parsed.map((item) => String(item).trim()).filter(Boolean);
  }
  return [s];
}
